import React from 'react';
import { List, Datagrid, TextField, DateField } from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = {};

const EventLogList = ({ classes, ...props }) => (
    <List {...props} title="Log de Eventos de Ficha Técnica" exporter={false}>
        <Datagrid>
            <TextField source="id" />
            <TextField source="user" label="Usuario" />
            <TextField source="type" label="Acción" />
            <TextField source="object_name" label="Nombre Objeto" />
            <DateField source="date" label="Fecha y Hora" showTime />
            <TextField source="data" label="Cambios" />
        </Datagrid>
    </List>
);

export default withStyles(styles)(EventLogList);
